import { CHART_COLORS } from 'utils/taskAnalytics'
import { PRIORITY_VALUES } from '../utils'
import { EditorContent } from 'components/CommonComponents/RichTextEditor'

export interface TaskPdfSubtask {
  title: string
  type: number
  is_required?: boolean
  order_index: number
  category?: string
  disable_gallery_upload?: boolean
  content?: {
    text?: string
    rich_text?: EditorContent | null
    images?: string[]
    videos?: string[]
    files?: string[]
  }
}

export interface TaskPdfContent {
  text: string | null
  rich_text?: EditorContent | null
  images: string[] | null
  videos: string[] | null
  files: string[] | null
  index_ref: number
}

export interface TaskPdfAudience {
  groups: string[]
  users: string[]
  tags: string[]
}

export interface TaskPdfData {
  // Task Creation Step
  title: string
  sub_tasks: TaskPdfSubtask[]
  contents: TaskPdfContent[]

  // Task Settings Step
  audience: TaskPdfAudience
  folderName?: string
  priority: PRIORITY_VALUES
  view: number | null
  is_individual_results: boolean
  send_schedule_push: boolean
  disable_gallery_upload: boolean
  rework_limit: number | null
  allow_completion_after_deadline: boolean
  // auto_approve_skipped_subtasks: boolean

  // Time Frame Step
  from_ts: string
  deadline: string
  is_recurring: boolean
  recurrence_frequency: number | null
  days_of_week: number[] | null
  frequency_time?: string
  monthly_range?: string[]
  allowed_overdue_days: number
}

export const SUBTASK_TYPE_LABELS: Record<number, string> = {
  0: 'Text',
  1: 'Product',
  2: 'Take a photo',
  3: 'Open a link',
  4: 'Record a video',
  5: 'Upload file',
  6: 'Poll',
  8: 'Open question',
  10: 'Quiz',
  [-1]: 'Description',
}

export const PRIORITY_LABELS: Record<PRIORITY_VALUES, string> = {
  [PRIORITY_VALUES.LOW]: 'Low',
  [PRIORITY_VALUES.MEDIUM]: 'Medium',
  [PRIORITY_VALUES.HIGH]: 'High',
  [PRIORITY_VALUES.NONE]: 'None',
}

export const PRIORITY_COLORS: Record<PRIORITY_VALUES, { bg: string; text: string }> = {
  [PRIORITY_VALUES.LOW]: { bg: CHART_COLORS.done, text: CHART_COLORS.doneText },
  [PRIORITY_VALUES.MEDIUM]: { bg: CHART_COLORS.inProgress, text: CHART_COLORS.inProgressText },
  [PRIORITY_VALUES.HIGH]: { bg: CHART_COLORS.rejected, text: CHART_COLORS.rejectedText },
  [PRIORITY_VALUES.NONE]: { bg: CHART_COLORS.todo, text: CHART_COLORS.todoText },
}
